
        var result = require("!!../../../../node_modules/css-loader/index.js!./bookmarks.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Client/app/views/contract.awards/bookmarks.component.css
// module id = 1207
// module chunks = 0